import primer from './primer';

export const baseFont = "'Libre Franklin', -apple-system, BlinkMacSystemFont, 'avenir next', avenir, 'helvetica neue', helvetica, ubuntu, roboto, noto, 'segoe ui', arial, sans-serif";

export const colors = {
  primary: '#971E23',
  pr: primer
};
